/**
 * @FileDescription: 枚举类缓存
 * @Author: fanqixin
 * @Date: 2021-10-19 17:25:35
 * @LastEditors: fanqixin
 * @LastEditTime: 2021-10-19 17:25:35
 */
const enumStore = {
	namespaced: true,
	state: {},
	getters: {
		getEnum(state) {
			return (enumClass) => {
				if (!Array.isArray(enumClass)) {
					enumClass = [enumClass]
				}
				let enumObj = new Object()
				for (let i = 0, len = enumClass.length; i < len; i++) {
					let key = enumClass[i]
					enumObj[key] = state[key];
				}
				return enumObj
			}
		}
	},
	mutations: {
		setEnum(state, enumObj) {
			for (let key in enumObj) {
				state[key] = enumObj[key]
			}
		}
	},
	actions: {
		setEnum({
			commit
		}, enumObj) {
			commit('setEnum', enumObj);
		},
	}
}
export default enumStore;
